module.exports = __webpack_public_path__ + "static/Stopy_do_obudowy-53074651b504451f2124f8b2b369e230.png";